/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pricing } from './Pricing';
import {
    PricingFromJSON,
    PricingFromJSONTyped,
    PricingToJSON,
    PricingToJSONTyped,
} from './Pricing';
import type { CompactFlight } from './CompactFlight';
import {
    CompactFlightFromJSON,
    CompactFlightFromJSONTyped,
    CompactFlightToJSON,
    CompactFlightToJSONTyped,
} from './CompactFlight';

/**
 * Flight offer for a specific cruise and price model
 * For trans cruises with an embarkation or disembarkation port in Germany this
 * could be an outbound or inbound flight only
 * 
 * @export
 * @interface CompactFlightOffer
 */
export interface CompactFlightOffer {
    /**
     * Reference to a price model offer
     * @type {string}
     * @memberof CompactFlightOffer
     */
    priceModelCode: string;
    /**
     * 
     * @type {CompactFlight}
     * @memberof CompactFlightOffer
     */
    flight: CompactFlight;
    /**
     * List of pricings corresponding with the requested pax configuration
     * Currently the complete price if entered in pricings[0], all other items display an amount of zero
     * 
     * @type {Array<Pricing>}
     * @memberof CompactFlightOffer
     */
    pricings: Array<Pricing>;
}

/**
 * Check if a given object implements the CompactFlightOffer interface.
 */
export function instanceOfCompactFlightOffer(value: object): value is CompactFlightOffer {
    if (!('priceModelCode' in value) || value['priceModelCode'] === undefined) return false;
    if (!('flight' in value) || value['flight'] === undefined) return false;
    if (!('pricings' in value) || value['pricings'] === undefined) return false;
    return true;
}

export function CompactFlightOfferFromJSON(json: any): CompactFlightOffer {
    return CompactFlightOfferFromJSONTyped(json, false);
}

export function CompactFlightOfferFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompactFlightOffer {
    if (json == null) {
        return json;
    }
    return {
        
        'priceModelCode': json['priceModelCode'],
        'flight': CompactFlightFromJSON(json['flight']),
        'pricings': ((json['pricings'] as Array<any>).map(PricingFromJSON)),
    };
}

export function CompactFlightOfferToJSON(json: any): CompactFlightOffer {
    return CompactFlightOfferToJSONTyped(json, false);
}

export function CompactFlightOfferToJSONTyped(value?: CompactFlightOffer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceModelCode': value['priceModelCode'],
        'flight': CompactFlightToJSON(value['flight']),
        'pricings': ((value['pricings'] as Array<any>).map(PricingToJSON)),
    };
}

